import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import _ from 'underscore';
import GraphView from './GraphView';

import config from './../config';
import utils from './../lib/graphUtils';
import helpers from './../lib/helpers';

class PersonGraphView extends Component {
	constructor(props) {
		super(props);

		this.url = config.neo4jApi+'/folklore/tengslanet';

		this.state = {
			graphData: {},
			graphMode: 1
		};
	}

	componentDidMount() {
		if (this.props.personId) {
			this.getData(this.props.personId);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.personId && this.props.personId != prevProps.personId) {
			this.getData(this.props.personId)
		}
	}

	getData(personId) {
		let params = [];

		if (this.state.graphMode == 3) {
			params.push('extended=true');
		}

		helpers.fetch(this.url+'?pid='+personId+(params.length > 0 ? '&'+params.join('&') : ''), (json) => {
			if (json) {
				this.setState({
					graphData: utils.groupGraphData(json)
				});

				if (this.props.onResponse) {
					this.props.onResponse({
						nodes: json.nodes || [],
						connections: json.connections || []
					});
				}
			}
		});
	}

	render() {
		return <div>
			{
				this.props.children
			}
			<GraphView straightLines={true}
				distance={200}
				graphData={this.state.graphData}
				uniqueId={this.props.graphSection}
				disableZoom={false}
				highlightId={[this.props.personId]}
				mainId={this.props.personId}
				onNodeClick={function(d) {
					this.props.history.push(helpers.routerUrls[d.label.toLowerCase()]+d.properties.ismus_id.low+(this.props.tabname ? '/'+this.props.tabname : ''));
				}.bind(this)}
				enableFullView={true}>
			</GraphView>
		</div>
	}
}


export default withRouter(PersonGraphView);
